/** @format */

export enum CookieConsentCategories {
    STRICTLY_NECESSARY = 1,
    PERFORMANCE = 2,
    FUNCTIONAL = 3,
    TARGETING = 4,
    SOCIAL_MEDIA = 5,
}
